import { useState, useMemo } from "react";
import { useLatest } from "../../../hooks";
import { fetchEmployees } from "../utils";
import * as f from "../../../utils/formatter";
import { role } from "shared/src/roles.mjs";

export const useDoctorOptions = (location_id) => {
  const [options, setOptions] = useState();
  useLatest(
    async (signal) => {
      if (location_id == null) {
        setOptions([]);
        return;
      }

      const doctors = await fetchEmployees(signal, {
        roles: {
          location_id: location_id,
          role: role.Doctor,
        },
      });

      setOptions(
        doctors.map((doctor) => ({
          ...doctor,
          name: f.fullName(doctor),
        })),
      );
    },
    [location_id],
  );

  return useMemo(
    () => ({ options: options ?? [], loading: options == null }),
    [options],
  );
};
